import { Tooltip } from 'antd';
import type { InternalTableRecord, ScopeItem } from '../types';

const getScopeLabel = (scopeItem: ScopeItem) => {
    const rawLabel = scopeItem.attribute_type || scopeItem.dimension || 'Scope';
    return rawLabel.replace(/\b\w/g, (ch) => ch.toUpperCase());
};

const ScopeCell = ({ record }: { record: InternalTableRecord }) => {
    if (!record.scope?.length) {
        return <>-</>;
    }

    const hasScopeValues = record.scope.some(
        (scopeItem) => (scopeItem.attribute_ex_id ?? []).length > 0
    );

    const tiles = (
        <div className="flex items-center gap-1.5 flex-wrap cursor-default">
            {record.scope.map((scopeItem, index) => {
                const label = getScopeLabel(scopeItem);
                const values = scopeItem.attribute_ex_id ?? [];
                const key = `${scopeItem.attribute_type || scopeItem.dimension || 'scope'}-${index}`;

                return (
                    <span
                        key={key}
                        className="rounded border border-[#E4E4E7] bg-[#FAFAFA] px-1.5 py-0.5 text-[12px] leading-[16px] text-[#52525B]"
                    >
                        {label} ({values.length})
                    </span>
                );
            })}
        </div>
    );

    if (!hasScopeValues) {
        return tiles;
    }

    return (
        <Tooltip
            color="black"
            placement="top"
            trigger="hover"
            mouseEnterDelay={0.1}
            overlayInnerStyle={{
                padding: '16px 8px',
                maxWidth: 344,
                borderRadius: 8,
            }}
            title={
                <div className="flex flex-col gap-1 text-[12px] leading-[18px]">
                    {record.scope.map((scopeItem, index) => {
                        const label = getScopeLabel(scopeItem);
                        const values = scopeItem.attribute_ex_id ?? [];
                        const key = `${scopeItem.attribute_type || scopeItem.dimension || 'scope'}-${index}`;

                        return (
                            <div key={key}>
                                {`${label} (${values.length}): ${values.join(', ')}`}
                            </div>
                        );
                    })}
                </div>
            }
        >
            {tiles}
        </Tooltip>
    );
};

export default ScopeCell;
